<template>
  <div class="insight-card">
    <h3 class="section-title">
      <span class="icon"><i class="mdi mdi-briefcase"></i></span>
      Work Preferences
    </h3>
    <p class="card-text" v-if="workPreferences">{{ workPreferences }}</p>
    <div v-else class="empty-state">
      <p>No work preferences found.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WorkPreferences',
  props: {
    workPreferences: {
      type: String,
      required: true
    }
  },
  mounted() {
    console.log('WorkPreferences component mounted with workPreferences:', this.workPreferences);
  }
};
</script>

<style lang="scss" scoped>
.insight-card {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.08);
  padding: 1.5rem 2rem;
  margin-bottom: 2rem;
  width: 100%;
}
.section-title {
  display: flex;
  align-items: center;
  color: $color-text;
  font-size: 1.4rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid $color-border-muted;
  .icon {
    margin-right: 12px;
    color: $color-primary;
    font-size: 1.4rem;
  }
}
.card-text {
  font-size: 1rem;
  color: $color-text-muted;
  line-height: 1.6;
}
.empty-state {
  text-align: center;
  color: $color-text-subtle;
  font-size: 1rem;
  padding: 2rem 0;
}
</style>